module.exports = __webpack_public_path__ + "static/media/ax.62ea912b.svg";